export enum SpecialDropdownEvents {
  SELECT = '@SpecialDropdown/SELECT'
}
